// PATH: src/components/StudentAvatar.tsx — pastille d'initiales d'un élève.
// Partagée par la liste des élèves et les bulletins : même élève, même couleur
// d'un écran à l'autre, ce qui aide à le retrouver dans une longue liste.
import React from "react";
import { Avatar } from "antd";

export const initials = (lastName?: string, firstName?: string) =>
  `${lastName?.[0] ?? ""}${firstName?.[0] ?? ""}`.toUpperCase() || "?";

// Teinte dérivée de l'id : stable d'un rendu à l'autre (pas d'aléatoire), et
// deux élèves voisins dans la liste ne reçoivent pas la même pastille.
const AVATAR_COLORS = ["#2563EB", "#0891B2", "#7C3AED", "#059669", "#D97706", "#DB2777"];
export const avatarColor = (id: number) => AVATAR_COLORS[id % AVATAR_COLORS.length];

const StudentAvatar: React.FC<{
  id: number;
  lastName?: string;
  firstName?: string;
  size?: number;
  photoUrl?: string;
}> = ({ id, lastName, firstName, size = 34, photoUrl }) => (
  // Avec photoUrl, antd affiche l'image ; les initiales restent le repli
  // naturel si l'URL est vide ou l'image échoue à charger.
  <Avatar
    size={size}
    src={photoUrl || undefined}
    style={{
      backgroundColor: photoUrl ? undefined : avatarColor(id),
      fontSize: size <= 28 ? 11 : 12,
      fontWeight: 600,
      flexShrink: 0,
    }}
  >
    {initials(lastName, firstName)}
  </Avatar>
);

export default StudentAvatar;
